var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtflixLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1728,
    height: 1117,
    viewBox: "0 0 1728 1117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2197_125)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1728,
    height: 1117,
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.596 574.215H870.167C869.912 580.073 868.712 585.039 866.565 589.113C864.455 593.152 861.417 596.226 857.451 598.336C853.522 600.446 848.738 601.501 843.099 601.501C838.806 601.501 834.967 600.756 831.584 599.264C828.2 597.736 825.326 595.535 822.962 592.661C820.633 589.786 818.85 586.257 817.613 582.074C816.413 577.853 815.812 573.033 815.812 567.612V553.805C815.812 548.384 816.449 543.563 817.723 539.343C818.996 535.123 820.815 531.557 823.18 528.647C825.581 525.736 828.492 523.535 831.911 522.044C835.331 520.552 839.188 519.806 843.481 519.806C849.156 519.806 853.904 520.879 857.724 523.026C861.544 525.172 864.491 528.319 866.565 532.467C868.639 536.578 869.858 541.599 870.221 547.529H855.651C855.505 543.673 855.032 540.617 854.232 538.361C853.431 536.069 852.176 534.432 850.466 533.449C848.756 532.467 846.428 531.976 843.481 531.976C841.189 531.976 839.206 532.394 837.532 533.231C835.859 534.068 834.495 535.378 833.439 537.16C832.384 538.907 831.602 541.144 831.093 543.873C830.583 546.601 830.329 549.876 830.329 553.696V567.612C830.329 571.286 830.547 574.488 830.984 577.217C831.42 579.945 832.112 582.219 833.057 584.038C834.04 585.821 835.349 587.167 836.987 588.076C838.624 588.95 840.661 589.386 843.099 589.386C846.046 589.386 848.392 588.95 850.139 588.076C851.885 587.167 853.177 585.621 854.013 583.438C854.886 581.219 855.414 578.144 855.596 574.215Z",
    fill: "url(#paint0_linear_2197_125)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.514 520.952V600.41H894.997V520.952H909.514ZM929.542 520.952V533.176H875.297V520.952H929.542Z",
    fill: "url(#paint1_linear_2197_125)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M954.045 520.952V600.41H939.419V520.952H954.045ZM979.367 555.169V567.339H950.498V555.169H979.367ZM982.75 520.952V533.176H950.498V520.952H982.75Z",
    fill: "url(#paint2_linear_2197_125)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1036.23 588.24V600.41H1003.21V588.24H1036.23ZM1007.42 520.952V600.41H992.791V520.952H1007.42Z",
    fill: "url(#paint3_linear_2197_125)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1061.33 520.952V600.41H1046.82V520.952H1061.33Z",
    fill: "url(#paint4_linear_2197_125)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1089.33 520.952L1101.55 548.402L1113.29 520.952H1129.61L1110.07 560.299L1129.99 600.41H1113.12L1100.9 572.414L1088.73 600.41H1072.19L1092.33 560.026L1072.63 520.952H1089.33Z",
    fill: "url(#paint5_linear_2197_125)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.157 520.011C748.038 514.284 740.711 511 733.054 511H625.01C617.352 511 610.025 514.284 604.907 520.011C599.802 525.732 597.337 533.406 598.154 541.061L602.53 581.775C604.015 595.584 615.562 606 629.385 606H643.174C653.216 606 662.366 600.463 667.059 591.54L673.879 578.559C675.358 575.749 677.965 575.444 679.018 575.444C680.072 575.444 682.685 575.749 684.164 578.559L690.984 591.533C695.677 600.449 704.827 605.993 714.869 605.993H728.664C742.487 605.993 754.035 595.577 755.52 581.768L759.903 541.054C760.727 533.406 758.262 525.732 753.15 520.005L753.157 520.011ZM614.961 529.077C617.555 526.173 621.127 524.571 625.01 524.571H645.268V531.357C645.268 535.096 642.236 538.143 638.515 538.143H611.578C611.572 534.797 612.699 531.608 614.961 529.077ZM746.478 539.609L742.096 580.323C741.353 587.231 735.579 592.435 728.671 592.435H714.875C709.851 592.435 705.28 589.667 702.93 585.202L696.109 572.227C692.753 565.849 686.21 561.879 679.025 561.879C671.847 561.879 665.297 565.842 661.94 572.221L655.12 585.202C652.777 589.66 648.199 592.429 643.181 592.429H629.392C622.484 592.429 616.71 587.217 615.961 580.316L612.882 551.714H638.508C649.677 551.714 658.767 542.581 658.767 531.357V524.571H733.047C736.937 524.571 740.502 526.173 743.102 529.077C745.695 531.981 746.897 535.727 746.478 539.609Z",
    fill: "url(#paint6_linear_2197_125)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2197_125)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 863.831,
    cy: -332.236,
    r: 387.733,
    transform: "rotate(75 863.831 -332.236)",
    fill: "url(#paint7_linear_2197_125)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2197_125)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 863.832,
    cy: 1407.76,
    r: 387.733,
    transform: "rotate(-15 863.832 1407.76)",
    fill: "url(#paint8_linear_2197_125)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2197_125",
    x: -23.998,
    y: -1220.07,
    width: 1775.66,
    height: 1775.66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 250,
    result: "effect1_foregroundBlur_2197_125"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2197_125",
    x: -23.998,
    y: 519.935,
    width: 1775.66,
    height: 1775.66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 250,
    result: "effect1_foregroundBlur_2197_125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2197_125",
    x1: 825.322,
    y1: 560.654,
    x2: 1036.71,
    y2: 691.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.275,
    stopColor: "#FCEC9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#FF7A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#B1CAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3FFD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2197_125",
    x1: 825.322,
    y1: 560.654,
    x2: 1036.71,
    y2: 691.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.275,
    stopColor: "#FCEC9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#FF7A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#B1CAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3FFD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2197_125",
    x1: 825.322,
    y1: 560.654,
    x2: 1036.71,
    y2: 691.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.275,
    stopColor: "#FCEC9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#FF7A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#B1CAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3FFD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2197_125",
    x1: 825.322,
    y1: 560.654,
    x2: 1036.71,
    y2: 691.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.275,
    stopColor: "#FCEC9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#FF7A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#B1CAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3FFD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2197_125",
    x1: 825.322,
    y1: 560.654,
    x2: 1036.71,
    y2: 691.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.275,
    stopColor: "#FCEC9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#FF7A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#B1CAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3FFD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2197_125",
    x1: 825.322,
    y1: 560.654,
    x2: 1036.71,
    y2: 691.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.275,
    stopColor: "#FCEC9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#FF7A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#B1CAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3FFD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2197_125",
    x1: 602.905,
    y1: 558.5,
    x2: 743.217,
    y2: 597.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.275,
    stopColor: "#FCEC9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#FF7A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#B1CAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3FFD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2197_125",
    x1: 499.57,
    y1: -332.236,
    x2: 1203.44,
    y2: -218.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.275,
    stopColor: "#FCEC9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#FF7A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#B1CAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3FFD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2197_125",
    x1: 499.571,
    y1: 1407.76,
    x2: 1203.44,
    y2: 1521.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.275,
    stopColor: "#FCEC9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#FF7A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#B1CAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3FFD1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2197_125"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1728,
    height: 1117,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtflixLoading);
export default __webpack_public_path__ + "static/media/ctflix-loading.c27bc469c272bb9812b8a895a3153094.svg";
export { ForwardRef as ReactComponent };